import { FlyerStatus } from '@/types/flyer';

export type GetFlyersResponse = {
  flyers: Flyer[];
};

export type GetFlyerResponse = {
  getFlyer: Flyer;
};

export type FlyerLinks = {
  androidAppUrl?: string;
  callNowUrl?: string;
  contactEmailUrl?: string;
  donateNowUrl?: string;
  iosAppUrl?: string;
  learnMoreUrl?: string;
  signUpNowUrl?: string;
};

export type Vertex = {
  x: number;
  y: number;
};

export type ParagraphInfo = {
  pageNumber: number;
  vertices: Vertex[];
};

export type CallToAction = {
  id?: string | null;
  type: string;
  value: string;
  isPrimary: boolean;
  paragraph?: ParagraphInfo;
};

export type TitleTranslations = {
  [key: string]: string;
};

export type Flyer = {
  flyerId: number;
  startDate: number;
  endDate: number;
  submittedAt: string;
  eventComplement?: string;
  districtId: number;
  isNew: boolean;
  isUpcoming: boolean;
  title: string;
  status: FlyerStatus;
  frontImageUrl: string;
  pageCount: number;
  email: string;
  pages: Page[];
  pdfUrl: string;
  type: string;
  ownerId: string;
  activities: string[];
  categories: string[];
  schools: FlyerSchool[];
  isFavorite: boolean;
  isRead: boolean;
  grades: string[];
  eventLocation: string;
  mapUrl: string;
  viewsPerDay: number;
  distributionsReleased?: number;
  savedAmount: number;
  org?: FlyerOrganization;
  criticalDate?: string;
  links?: FlyerLinks;
  minTargetGradeOrAge?: string;
  maxTargetGradeOrAge?: string;
  schoolCount?: number;
  ctas: CallToAction[];
  featuredLinkIds?: string[];
  wcagHtml?: string;
  isQuarantined?: boolean;
  isExpandedCommunity?: boolean;
  titleTranslations: TitleTranslations;
  isCommunityFree?: boolean;
  translations?: object;
};

export type Page = {
  imageUrl: string;
  pageNumber: number;
  userText: string;
};

export type FlyerSchool = {
  schoolId: string;
  name: string;
  districtId: number;
  branding: {
    logoAlt: string;
    logoLinkUrl: string;
    logoUrl: string;
  };
  treeCounter: number;
  sheetCounter: number;
};

export type FlyerOrganization = {
  orgId: string;
  name: string;
  description: string;
  disclaimer: string;
  schoolApproved: boolean;
  approvedFlyerCount: number;
  childEnrichmentStatement: string;
  isFollowing: boolean;
  links: {
    call: string;
    website: string;
    email: string;
  };
};

export enum CallToActionEnum {
  Call = 'call',
  Download = 'download',
  Email = 'email',
  GetApp = 'get-app',
  App = 'app',
  JoinMeeting = 'join-meeting',
  LearnMore = 'learn-more',
  Order = 'order',
  Register = 'register',
  RSVP = 'rsvp',
  SignUp = 'signup',
  Subscribe = 'subscribe',
  Survey = 'survey',
  Map = 'map',
}
